import { z } from 'zod';
import { PaginatedSchema, PagingSchema } from '../shared';
import { SessionListItemSchema } from './dto';

export const FilterSessionsSchema = z.object({
  status: z.enum(['OPEN', 'PAST']),
  studyId: z.string().uuid(),
});

export type FilterSessions = z.infer<typeof FilterSessionsSchema>;

export const ListSessionsSchema = z.intersection(
  FilterSessionsSchema,
  PagingSchema,
);

export type ListSessions = z.infer<typeof ListSessionsSchema>;

export const ListSessionsResponseSchema = PaginatedSchema(
  SessionListItemSchema,
);

export type ListSessionsResponse = z.infer<typeof ListSessionsResponseSchema>;
